// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Grid,
//   Button,
//   TextField,
//   CircularProgress,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";

// const RegistrationFormSection = ({ registrationRef }) => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     countryCode: "",
//     phone: "",
//   });

//   const [errors, setErrors] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//   });

//   const [countryCode, setCountryCode] = useState("us");
//   const [dialCode, setDialCode] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchCountryCode = async () => {
//       try {
//         const response = await fetch("https://ipwho.is/");
//         const data = await response.json();

//         if (data.success) {
//           const country = data.country_code.toLowerCase();
//           setCountryCode(country);

//           const countryData = PhoneInput.getCountryData(country);
//           if (countryData) {
//             setDialCode(`+${countryData.dialCode}`);
//           }
//         }
//       } catch (error) {
//         console.error("Ошибка определения кода страны:", error);
//       }
//     };

//     fetchCountryCode();
//   }, []);

//   const handleChange = (value, field) => {
//     let newValue = value;

//     if (field === "phone") {
//       newValue = value.replace(/\D/g, ""); // Оставляем только цифры ТОЛЬКО для телефона
//     }

//     setFormData((prevData) => ({
//       ...prevData,
//       [field]: newValue,
//     }));

//     validateField(field, newValue);
//   };

//   const validateField = (field, value) => {
//     let error = "";

//     if (field === "firstName" || field === "lastName") {
//       const nameRegex = /^[a-zA-Zа-яА-ЯёЁ]+$/;
//       if (!nameRegex.test(value)) {
//         error =
//           "Имя и фамилия не должны содержать цифры или специальные символы";
//       }
//     }
//     if (field === "email") {
//       const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//       if (!emailRegex.test(value)) {
//         error = "Введите корректный email";
//       }
//     }
//     if (field === "phone") {
//       if (value.length < 7 || value.length > 15) {
//         error = "Введите корректный номер";
//       }
//     }

//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       [field]: error,
//     }));
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setLoading(true);

//     const dataToSend = {
//       firstName: formData.firstName,
//       lastName: formData.lastName,
//       email: formData.email,
//       phone: formData.phone,
//     };

//     try {
//       const response = await fetch(
//         "https://script.google.com/macros/s/AKfycbzGeiZ1bgPi5mHzrqJMqqvpAdffMoLRyOSWpachBpKR44nl59lDPmaOka9gAebrSL2DCA/exec",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           mode: "no-cors",
//           body: JSON.stringify(dataToSend),
//         }
//       );

//       navigate("/thank-you");
//     } catch (error) {
//       console.error("Ошибка при отправке:", error);
//       alert("Ошибка при отправке формы");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       ref={registrationRef}
//       sx={{
//         background: "#f5f5f5",
//         color: "#000",
//         py: 6,
//         px: 3,
//         textAlign: "center",
//         minHeight: "80vh",
//       }}
//     >
//       <Box sx={{ maxWidth: "900px", mx: "auto", mb: 6 }}>
//         <Typography
//           variant="h4"
//           fontWeight="bold"
//           sx={{ mb: 3, lineHeight: 1.3 }}
//         >
//           Сделайте первый шаг к вашему успеху!
//         </Typography>
//         <Typography variant="h6" sx={{ fontWeight: 400 }}>
//           Заполните форму ниже и получите бесплатную диагностическую сессию.
//         </Typography>
//       </Box>

//       <form
//         onSubmit={handleSubmit}
//         style={{ maxWidth: "600px", margin: "0 auto", textAlign: "left" }}
//         //   name="Adam-business-lead-form"
//         //   action="/thank-you"
//         //   method="POST"
//         //   data-netlify="true"
//         //   data-netlify-honeypot="bot-field"
//         //   onSubmit={handleSubmit}
//         //   style={{ maxWidth: "600px", margin: "0 auto", textAlign: "left" }}
//       >
//         {/* <input type="hidden" name="form-name" value="Adam-business-lead-form" />
//         <input type="hidden" name="bot-field" /> */}

//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Имя"
//               variant="outlined"
//               name="firstName"
//               required
//               value={formData.firstName}
//               onChange={(e) => handleChange(e.target.value, "firstName")}
//               error={!!errors.firstName}
//               helperText={errors.firstName}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Фамилия"
//               variant="outlined"
//               name="lastName"
//               required
//               value={formData.lastName}
//               onChange={(e) => handleChange(e.target.value, "lastName")}
//               error={!!errors.lastName}
//               helperText={errors.lastName}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Email"
//               variant="outlined"
//               name="email"
//               type="email"
//               required
//               value={formData.email}
//               onChange={(e) => handleChange(e.target.value, "email")}
//               error={!!errors.email}
//               helperText={errors.email}
//             />
//           </Grid>

//           {/* Поле для номера телефона */}
//           <Grid item xs={12}>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 border: errors.phone ? "1px solid red" : "1px solid #999",
//                 borderRadius: "8px",
//                 padding: "10px",
//                 width: "100%",
//               }}
//             >
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   paddingRight: "8px",
//                 }}
//               >
//                 <PhoneInput
//                   country={countryCode}
//                   value={countryCode}
//                   inputProps={{ name: "phone", required: true }}
//                   inputStyle={{
//                     width: "90px",
//                     border: "none",
//                     backgroundColor: "transparent",
//                     fontSize: "16px",
//                     outline: "none",
//                     paddingLeft: "40px",
//                     pointerEvents: "none",
//                   }}
//                   buttonStyle={{
//                     backgroundColor: "transparent",
//                     border: "none",
//                     pointerEvents: "none",
//                   }}
//                   dropdownStyle={{ backgroundColor: "#222", color: "#000" }}
//                 />
//                 <Typography sx={{ fontSize: "20px", marginRight: "8px" }}>
//                   |
//                 </Typography>
//               </Box>

//               <TextField
//                 fullWidth
//                 placeholder="Введите номер"
//                 name="phone"
//                 variant="standard"
//                 value={formData.phone}
//                 onChange={(e) =>
//                   handleChange(e.target.value.replace(/\D/g, ""), "phone")
//                 }
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   disableUnderline: true,
//                   style: { textAlign: "left" },
//                 }}
//                 sx={{
//                   flex: 1,
//                   "& input": {
//                     textAlign: "left",
//                   },
//                 }}
//               />
//             </Box>
//           </Grid>

//           <Grid item xs={12}>
//             <Button
//               fullWidth
//               variant="contained"
//               type="submit"
//               disabled={loading} // 🔒 Блокируем кнопку во время отправки
//               sx={{
//                 background:
//                   "linear-gradient(to right, #cc7472, #d47ca2, #bba8e0)",
//                 color: "#fff",
//                 fontSize: "1.2rem",
//                 padding: "0.8rem 1.5rem",
//                 borderRadius: "50px",
//                 textTransform: "uppercase",
//               }}
//               //   type="submit"
//             >
//               {loading ? (
//                 <CircularProgress size={24} sx={{ color: "#fff" }} />
//               ) : (
//                 "Записаться на сессию"
//               )}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default RegistrationFormSection;
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";

const RegistrationFormSection = ({ registrationRef }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "",
    phone: "",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const [countryCode, setCountryCode] = useState("us");
  const [dialCode, setDialCode] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await fetch("https://ipwho.is/");
        if (!response.ok) {
          throw new Error("Ошибка при получении данных");
        }
        const data = await response.json();

        console.log("Ответ API ipwho.is:", data);

        if (data.success && data.calling_code) {
          const country = data.country_code.toLowerCase();
          const countryDialCode = `+${data.calling_code}`;

          console.log("Определённый код страны:", countryDialCode);

          setCountryCode(country);

          setFormData((prev) => ({
            ...prev,
            countryCode: countryDialCode,
          }));
        } else {
          throw new Error("Не удалось определить код страны");
        }
      } catch (error) {
        console.error("Ошибка определения кода страны:", error);
      }
    };

    fetchCountryCode();
  }, []);

  const handleChange = (value, field) => {
    let newValue = value;

    if (field === "phone") {
      newValue = value.replace(/\D/g, "");
    }

    setFormData((prevData) => ({
      ...prevData,
      [field]: newValue,
    }));

    validateField(field, newValue);
  };

  const validateField = (field, value) => {
    let error = "";

    if (field === "firstName" || field === "lastName") {
      const nameRegex = /^[a-zA-Zа-яА-ЯёЁ]+$/;
      if (!nameRegex.test(value)) {
        error =
          "Имя и фамилия не должны содержать цифры или специальные символы";
      }
    }
    if (field === "email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(value)) {
        error = "Введите корректный email";
      }
    }

    if (field === "phone") {
      if (value.length < 7 || value.length > 15) {
        error = "Введите корректный номер";
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: error,
    }));
  };

  const handlePhoneChange = (value, countryData) => {
    console.log("Выбранная страна:", countryData);

    if (!countryData || !countryData.dialCode) {
      console.error(
        "Ошибка: countryData отсутствует или не содержит dialCode!"
      );
      return;
    }

    setFormData((prev) => ({
      ...prev,
      countryCode: `+${countryData.dialCode}`, // ✅ Сохраняем код страны
    }));
  };

  const handleTextFieldChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Оставляем только цифры
    if (value.length > 15) value = value.slice(0, 15);
    setFormData((prev) => ({ ...prev, phone: value }));
  };

  //   const handleSubmit = async (event) => {
  //     event.preventDefault();
  //     setLoading(true);

  //     if (!formData.countryCode || formData.countryCode === "+undefined") {
  //       alert("Ошибка: Код страны не определён!");
  //       setLoading(false);
  //       return;
  //     }

  //     console.log("Код страны перед отправкой:", formData.countryCode);
  //     console.log("Номер перед отправкой:", formData.phone);

  //     if (!formData.countryCode || !formData.phone) {
  //       alert("Ошибка: убедитесь, что введён номер и код страны!");
  //       setLoading(false);
  //       return;
  //     }

  //     const dataToSend = {
  //       firstName: formData.firstName,
  //       lastName: formData.lastName,
  //       email: formData.email,
  //       countryCode: formData.countryCode, // ✅ Код страны
  //       phone: formData.phone, // ✅ Только номер (без кода)
  //     };

  //     try {
  //       const response = await fetch(
  //         "https://script.google.com/macros/s/AKfycbyN3ZikHaCCxOrYVsQ5OtuUHYScpqEnnmmpxfjZoY35AxE5j1s5EQqVJiaf_1Rlbci_cw/exec",
  //         {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           mode: "no-cors",
  //           body: JSON.stringify(dataToSend),
  //         }
  //       );
  //       navigate("/thank-you");
  //     } catch (error) {
  //       console.error("Ошибка при отправке:", error);
  //       alert("Ошибка при отправке формы");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!formData.countryCode || formData.countryCode === "+undefined") {
      alert("Ошибка: Код страны не определён!");
      setLoading(false);
      return;
    }

    console.log("Код страны перед отправкой:", formData.countryCode);
    console.log("Номер перед отправкой:", formData.phone);

    if (!formData.countryCode || !formData.phone) {
      alert("Ошибка: убедитесь, что введён номер и код страны!");
      setLoading(false);
      return;
    }

    const dataToSend = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      countryCode: formData.countryCode, // ✅ Код страны
      phone: formData.phone, // ✅ Только номер (без кода)
    };

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbyN3ZikHaCCxOrYVsQ5OtuUHYScpqEnnmmpxfjZoY35AxE5j1s5EQqVJiaf_1Rlbci_cw/exec",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "no-cors",
          body: JSON.stringify(dataToSend),
        }
      );

      // ✅ Передаем данные на страницу "Спасибо"
      navigate("/thank-you", { state: { ...dataToSend, formSubmitted: true } });
    } catch (error) {
      console.error("Ошибка при отправке:", error);
      alert("Ошибка при отправке формы");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      ref={registrationRef}
      sx={{
        background: "#f5f5f5",
        color: "#000",
        py: 6,
        px: 3,
        textAlign: "center",
        minHeight: "80vh",
      }}
    >
      <Box sx={{ maxWidth: "900px", mx: "auto", mb: 6 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ mb: 3, lineHeight: 1.3 }}
        >
          Сделайте первый шаг к гармоничной жизни!
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 400 }}>
          Заполните форму ниже и получите бесплатную диагностическую сессию.
        </Typography>
      </Box>

      <form
        onSubmit={handleSubmit}
        style={{ maxWidth: "600px", margin: "0 auto", textAlign: "left" }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Имя"
              variant="outlined"
              name="firstName"
              required
              value={formData.firstName}
              onChange={(e) => handleChange(e.target.value, "firstName")}
              error={!!errors.firstName}
              helperText={errors.firstName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Фамилия"
              variant="outlined"
              name="lastName"
              required
              value={formData.lastName}
              onChange={(e) => handleChange(e.target.value, "lastName")}
              error={!!errors.lastName}
              helperText={errors.lastName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              name="email"
              type="email"
              required
              value={formData.email}
              onChange={(e) => handleChange(e.target.value, "email")}
              error={!!errors.email}
              helperText={errors.email}
            />
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: errors.phone ? "1px solid red" : "1px solid #999",
                borderRadius: "8px",
                padding: "10px",
                backgroundColor: "transparent",
                color: "#fff",
                marginBottom: "20px",
                width: "100%",
              }}
            >
              {/* КОД СТРАНЫ */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "transparent",
                  paddingRight: "8px",
                }}
              >
                <PhoneInput
                  country={countryCode}
                  value={countryCode}
                  onChange={(value, country) =>
                    handlePhoneChange(value, country)
                  }
                  // onChange={(value) => handleChange(value, "phone")}
                  inputProps={{ name: "countryCode", required: true }}
                  inputStyle={{
                    width: "90px",
                    border: "none",
                    backgroundColor: "transparent",
                    color: "#000",
                    fontSize: "16px",
                    outline: "none",
                    paddingLeft: "40px",
                    pointerEvents: "none",
                  }}
                  buttonStyle={{
                    backgroundColor: "transparent",
                    border: "none",
                    marginRight: "0px",
                    pointerEvents: "none",
                  }}
                  dropdownStyle={{ backgroundColor: "#222", color: "#000" }}
                />

                <Typography
                  sx={{
                    color: "#000",
                    fontSize: "20px",
                    marginRight: "8px",
                  }}
                >
                  |
                </Typography>
              </Box>

              <TextField
                fullWidth
                placeholder="Введите номер"
                name="phone"
                variant="standard"
                value={formData.phone}
                onChange={handleTextFieldChange}
                error={!!errors.phone}
                helperText={errors.phone}
                InputProps={{
                  disableUnderline: true,
                  style: { textAlign: "left" },
                }}
                sx={{
                  flex: 1,
                  color: "#000",
                  "& input": {
                    color: "#000",
                    textAlign: "left",
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                background:
                  "linear-gradient(to right, #cc7472, #d47ca2, #bba8e0)",
                color: "#fff",
                fontSize: "1.2rem",
                padding: "0.8rem 1.5rem",
                borderRadius: "50px",
                textTransform: "uppercase",
                "&:hover": {
                  background: "linear-gradient(to right, #d0bf6f, #ad9e49)",
                },
              }}
              type="submit"
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : (
                " Записаться на сессию"
              )}{" "}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default RegistrationFormSection;
